import React, { useContext, Fragment } from 'react';
import { Modal, Table } from 'react-bootstrap';
import AppContext from 'context/Context';

/**
 * @description 한계기준이탈 원료 상세 Modal
 */

function RawMaterialDetail({ modalShow, setModalShow, detailModalData }) {
  const {
    config: { isDark }
  } = useContext(AppContext);

  const { itemNm, cycle, inOutType, list = [] } = detailModalData || {};

  return (
    <Modal
      show={modalShow}
      onHide={() => setModalShow(false)}
      backdrop="static"
      size="xl"
      centered
    >
      <Modal.Header
        closeButton
        closeVariant={isDark ? 'white' : undefined}
        className="px-card border-bottom-0"
      >
        <Modal.Title>한계기준이탈 상세</Modal.Title>
      </Modal.Header>
      <Modal.Body className="scrollbar max-vh-75">
        <p className="fs--1">
          [{itemNm || '-'}] [{cycle || '-'}] [{inOutType || '-'}] 한계기준이탈
          상세 내역
        </p>
        <div className="max-vh-50 scrollbar">
          <Table
            bordered
            className="fs--1 text-center"
            style={{ tableLayout: 'fixed' }}
          >
            <thead
              className="bg-200 text-700 align-middle border-300"
              style={{ position: 'sticky', top: 0 }}
            >
              <tr>
                <th>No.</th>
                <th>검사결과 Type</th>
                <th>모선명</th>
                <th>원료명</th>
                <th>CCP 포함여부</th>
                <th>검사의뢰일</th>
                <th>성분명칭</th>
              </tr>
            </thead>
            <tbody className="align-middle">
              {list?.map(
                (
                  {
                    inspResultTypeNm,
                    cshipNm,
                    sampleNm,
                    ccpYn,
                    inspReqDt,
                    inspResultIrdntExcdList = []
                  },
                  index
                ) => (
                  <Fragment key={index}>
                    <tr>
                      <td>{index + 1}</td>
                      <td>{inspResultTypeNm || '-'}</td>
                      <td>{cshipNm || '-'}</td>
                      <td>{sampleNm || '-'}</td>
                      <td>{ccpYn || '-'}</td>
                      <td>{inspReqDt || '-'}</td>
                      <td>
                        {inspResultIrdntExcdList
                          ?.map(e => e.inspIrdntNm)
                          .join(', ') || '-'}
                      </td>
                    </tr>
                  </Fragment>
                )
              )}
              {list.length < 1 && (
                <tr>
                  <td colSpan={7} className="w-auto">
                    한계기준 이탈현황 데이터가 존재하지 않습니다.
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default React.memo(RawMaterialDetail);
